import { computed, Injectable, signal } from '@angular/core';
import type { ColumnDefinition } from '../types/column.type';
import type {
  GalleryViewGridOptions,
  GridOptions,
  TableViewGridOptions,
} from '../types/grid-options.type';

/**
 * 시그널 기반 데이터 그리드 스토어
 * 각 상태를 개별 signal로 관리하여 불필요한 computed 래퍼 제거
 */
@Injectable({ providedIn: 'any' })
export class DataGridStore {
  // 개별 상태 시그널 (직접 접근)
  public readonly rowData = signal<any[]>([]);
  public readonly columns = signal<ColumnDefinition[]>([]);
  public readonly options = signal<GridOptions | null>(null);
  public readonly groupBy = signal<string | null>(null);

  // 타입별 옵션 (실제 계산이 필요하므로 computed 유지)
  public readonly tableOptions = computed<TableViewGridOptions>(
    () => this.options() as TableViewGridOptions
  );
  public readonly galleryOptions = computed<GalleryViewGridOptions>(
    () => this.options() as GalleryViewGridOptions
  );

  /**
   * 초기 상태를 설정합니다
   */
  public init(state: {
    rowData: any[];
    columns: ColumnDefinition[];
    options: GridOptions;
  }): void {
    this.rowData.set(state.rowData);
    this.columns.set(state.columns);
    this.options.set(state.options);
  }

  /**
   * groupBy를 설정합니다
   */
  public setGroupBy(groupByValue: string | null): void {
    this.groupBy.set(groupByValue);
  }

  /**
   * rowData를 업데이트합니다
   */
  public setRowData(data: any[]): void {
    this.rowData.set(data);
  }

  /**
   * columns를 업데이트합니다
   */
  public setColumns(cols: ColumnDefinition[]): void {
    this.columns.set(cols);
  }

  /**
   * options를 업데이트합니다
   */
  public setOptions(opts: GridOptions): void {
    this.options.set(opts);
  }
}
